/**
 * Disable-confirm dialog body for `BulkActionBar`. Lives outside the
 * component file (react-refresh wants component-only modules) and is pure
 * so the copy-selection logic — group-scoped "ALL pairs in {group}" vs
 * plain "ALL pairs" vs the selected-subset variant — is unit-testable
 * without mounting MUI.
 */
export function buildDisableConfirmBody(opts: {
  mode: 'selected' | 'all';
  noun: string;
  totalCount: number;
  selectedCount: number;
  groupLabel?: string | null;
}): string {
  const scope =
    opts.mode === 'all'
      ? `ALL ~${opts.totalCount} pair(s)${
          opts.groupLabel ? ` in ${opts.groupLabel}` : ''
        }`
      : `${opts.selectedCount} selected pair(s)`;
  return (
    `Disable ${opts.noun} for ${scope}? Active rules on them ` +
    'will be auto-paused and their Kalshi/Polymarket order books ' +
    'unsubscribed within ~5 minutes.'
  );
}
